// src/components/doubts/Doubts.jsx

import React, { useState } from "react";
import Text from '../text/Text'; // Verifique se o caminho para o Text está certo
import { doubtsData } from "../../data/doubts"; // Este caminho está correto
import './styles.css';

const Doubts = () => {
    const [openId, setOpenId] = useState(null);

    const handleToggle = (id) => {
        setOpenId(openId === id ? null : id);
    };

    return (
        <div className='container'>
            <div className='content'>
                <Text as="h1" fontSize={56} variant='yellow-green'>Dúvidas Frequentes</Text>
                <div id='doubts-content'>
                    {doubtsData.map((doubt) => (
                        <div className="doubt-item" key={doubt.id}>
                            <div 
                                className={`doubt ${openId === doubt.id ? 'active' : ''}`} 
                                onClick={() => handleToggle(doubt.id)}
                            >
                                <Text as="p" fontSize={22} isBold={true}>{doubt.question}</Text>
                                <span className="doubt-toggle">{openId === doubt.id ? '−' : '+'}</span>
                            </div>

                            {openId === doubt.id && (
                                <div className="answer">
                                    <Text as="p">{doubt.answer}</Text>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Doubts;